<div id="general" class="category-content active">
    <div class="stats-grid">
        <div class="stat-card">
            <span class="stat-number">3–6</span>
            <div class="stat-label">Agosto 2026</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">80</span>
            <div class="stat-label">Jugadores Inscritos</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">11</span>
            <div class="stat-label">Categorias</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">7</span>
            <div class="stat-label">Clubes</div>
        </div>
    </div>

    <div class="rules-grid">
        <div class="rule-card">
            <div>
                <svg width="80px" height="80px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 17V11" stroke="#3a5a40" stroke-width="1.5" stroke-linecap="round" />
                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#3a5a40" />
                    <path
                        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                        stroke="#3a5a40" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </div>
            <div class="rule-list">
                <ul>
                    <li>Todos los partidos se jugarán a 2 de 3 games, excepto la final de primera 3 de 5 games.</li>
                    <li>Uso de gafas es obligatorio</li>
                    <li>El buen comportamiento es fundamental para el buen desarrollo del torneo la buena conducta deportiva hace que nuestro deporte sea más sano y familiar tanto para deportistas como padres de familia o acompañantes</li>
                    <li>La programación está diseñada por bloques de horas, por favor llegar puntual a sus partidos (los jugadores deben asegurar presencia en el rango de la categoría que le corresponde). </li>
                    <li>La inscripción incluye camiseta y muchos premios.</li>
                </ul>
            </div>
        </div>
    </div>

    <h3 style="margin-bottom: 20px; color: #3a5a40; text-align: center;">Programación por bloques</h3>

    <div class="tab-content" style="display: block; margin-bottom: 2rem;">
        <h3 style="margin-bottom: 20px; color: #3a5a40;">Lunes 3 de Agosto 2026</h3>

        <div class="info-schedule">
            <div class="info">
                <div class="time"><span>desde</span>5:00 p.m. <br><span>hasta</span>6:30 p.m.</div>
                <div class="players">Juvenil / Infantil / Damas / Quinta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>6:30 p.m. <br><span>hasta</span>8:00 p.m.</div>
                <div class="players">Tercera / Sexta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>8:00 p.m. <br><span>hasta</span>9:30 p.m.</div>
                <div class="players">Segunda / Novatos</div>
            </div>
        </div>

        <h3 style="margin: 20px 0; color: #3a5a40;">Martes 4 de Agosto 2026</h3>

        <div class="info-schedule">
            <div class="info">
                <div class="time"><span>desde</span>5:00 p.m. <br><span>hasta</span>6:30 p.m.</div>
                <div class="players">Juvenil / Infantil / Damas / Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>6:30 p.m. <br><span>hasta</span>8:00 p.m.</div>
                <div class="players">Quinta / Cuarta / Tercera</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>8:00 p.m. <br><span>hasta</span>9:30 p.m.</div>
                <div class="players">Primera / Segunda</div>
            </div>
        </div>

        <h3 style="margin: 20px 0; color: #3a5a40;">Miércoles 5 de Agosto 2026</h3>

        <div class="info-schedule">
            <div class="info">
                <div class="time"><span>desde</span>5:00 p.m. <br><span>hasta</span>6:30 p.m.</div>
                <div class="players">Sexta / Cuarta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>6:30 p.m. <br><span>hasta</span>8:00 p.m.</div>
                <div class="players">Cuartos de final: Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>8:00 p.m. <br><span>hasta</span>9:30 p.m.</div>
                <div class="players">Primera</div>
            </div>
        </div>

        <h3 style="margin: 20px 0; color: #3a5a40;">Jueves 6 de Agosto 2026 – FINALES</h3>

        <div class="info-schedule">
            <div class="info">
                <div class="time"><span>desde</span>5:00 p.m.</div>
                <div class="players">Semifinal: Juvenil - Damas - Infantil - Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>6:00 p.m.</div>
                <div class="players">Semifinal: Tercera - Cuarta - Quinta - Sexta - Segunda - Primera</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>7:00 p.m.</div>
                <div class="players">Final: Juvenil - Infantil - Damas - Novatos</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>7:30 p.m.</div>
                <div class="players">Final: Segunda - Quinta - Tercera - Cuarta</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>8:00 p.m.</div>
                <div class="players">Final: Primera</div>
            </div>
        </div>

    </div>
</div>
